import LoanLayout from '../views/loan/Index'
import PayDayLoanList from '../views/loan/PayDayLoanList'
import PersonalLoanList from '../views/loan/PersonalLoanList'
import UnknownLoanTypeList from '../views/loan/UnknownLoanTypeList'
import PawnLoanList from '../views/loan/PawnLoanList'
import PurchasingLoanList from '../views/loan/PurchasingLoanList'
import Show from '../views/loan/Show'
import Edit from '../views/loan/Edit'
import Permissions from '@/permissions'

export const loanRouters = {
  path: 'loan',
  component: LoanLayout,
  redirect: '',
  meta: {
    permissions: [Permissions.backend.setting.manage],
    groups: 'payday'
  },
  children: [
    {
      path: 'pay-day-loan',
      name: 'PayDayLoanList',
      component: PayDayLoanList,
      meta: {
        permissions: [Permissions.backend.loan.payDay.list],
        groups: 'payday',
        breadcrumb: [
          {
            name_en: 'Loan',
            name_km: 'កម្ជី'
          },
          {
            name_en: 'Payday Loan',
            name_km: 'កម្ជីគិតជាថ្ងៃ'
          },
          {
            name_en: 'List',
            name_km: 'បញ្ជី'
          }
        ]
      }
    },
    {
      path: 'show/:loan_id',
      name: 'show-loan',
      component: Show
    },
    {
      path: 'edit/:loan_id',
      name: 'edit-loan',
      component: Edit
    },
    {
      path: 'personal-loan',
      name: 'PersonalLoanList',
      component: PersonalLoanList,
      meta: {
        permissions: [Permissions.backend.loan.personal.list],
        groups: 'personal',
        breadcrumb: [
          {
            name_en: 'Loan',
            name_km: 'កម្ជី'
          },
          {
            name_en: 'Personal Loan',
            name_km: 'កម្ជីគិតជាខែ'
          },
          {
            name_en: 'List',
            name_km: 'បញ្ជី'
          }
        ]
      }
    },
    {
      path: 'unknown-loan-type',
      name: 'UnknownLoanType',
      component: UnknownLoanTypeList
    },
    {
      path: 'pawn-loan',
      name: 'list-pawn-loan',
      component: PawnLoanList,
      meta: {
        permissions: [Permissions.backend.loan.pawn.list],
        groups: 'pawn',
        breadcrumb: [
          {
            name_en: 'Loan',
            name_km: 'កម្ជី'
          },
          {
            name_en: 'Pawn',
            name_km: 'កម្ជីបញ្ជំា'
          },
          {
            name_en: 'List',
            name_km: 'បញ្ជី'
          }
        ]
      }
    },
    {
      path: 'purchasing-loan',
      name: 'list-purchasing-loan',
      component: PurchasingLoanList,
      meta: {
        permissions: [Permissions.backend.loan.purchasing.list],
        groups: 'purchasing',
        breadcrumb: [
          {
            name_en: 'Loan',
            name_km: 'កម្ជី'
          },
          {
            name_en: 'Purchasing',
            name_km: 'កម្ជីបង់រំលោះ'
          },
          {
            name_en: 'List',
            name_km: 'បញ្ជី'
          }
        ]
      }
    }
  ]
}
